import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import HomePage from "@/pages/HomePage";
import CategoryPage from "@/pages/CategoryPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import SpotifyCallback from "@/pages/SpotifyCallback";
import FullscreenManager from "@/components/FullscreenManager";
import Screensaver from "@/components/Screensaver";
import UnifiedPlayer from "@/components/UnifiedPlayer";
import { Toaster } from "@/components/ui/sonner";

function App() {
  // Add global error handler to prevent error overlay from blocking UI
  useEffect(() => {
    const handleError = (event) => {
      // Log the error but don't let it block the UI
      console.error('Global error caught:', event.error || event.message);
      // Prevent default error overlay in production
      if (process.env.NODE_ENV === 'production') {
        event.preventDefault();
      }
    };

    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', (event) => {
      console.error('Unhandled promise rejection:', event.reason);
      if (process.env.NODE_ENV === 'production') {
        event.preventDefault();
      }
    });

    return () => {
      window.removeEventListener('error', handleError);
    };
  }, []);

  return (
    <div className="App">
      <FullscreenManager />
      <Screensaver />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/category/:categoryId" element={<CategoryPage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/spotify-callback" element={<SpotifyCallback />} />
        </Routes>
      </BrowserRouter>
      {/* UnifiedPlayer persists across all pages */}
      <UnifiedPlayer />
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
